<div
  class="flex h-full flex-row justify-center"
  *ngIf="
    params.data.rowType !== rowTypeEmpty &&
    params.data.rowType !== rowTypeHeader
  "
>
  <m-mini-charts-icon
    class="mt-1 flex h-7 w-7 cursor-pointer"
    [ngClass]="{
      'text-m500': params.data.showChart === true,
      'text-s400': params.data.showChart === false
    }"
    (click)="toggleShowChart($event)"
  ></m-mini-charts-icon>
</div>
